import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import AttachmentRequest from '@app/store/contract-progress/AttachmentRequest';

type AttachmentsState = AttachmentRequest[];

const initialState: AttachmentsState = [];

export default function reducer(
  state: AttachmentsState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
